import axios from 'axios'
import { SALES_ENDPOINT } from 'cfgCommon/endpoints'

export async function getSalesReport(args){
    const response = await axios(`${SALES_ENDPOINT}/generateExcel?desde=${args.from}&hasta=${args.to}`, {
        method: 'GET',
        timeout: 2400000, // 40 minutos
      })

    return response.data
} 
